// extracted by mini-css-extract-plugin
export var label = "_el-2";
export var slideContainer = "_el-0";
export var slider = "_el-1";